<script setup lang="ts">
defineProps<{
  img?: string;
  alt: string;
  firstImage?: boolean;
  noLazy?: boolean;
  noTransition?: boolean;
}>();

const emit = defineEmits<{
  (e: "load", event: Event): void;
}>();
function onImageLoad(e: Event) {
  emit("load", e);
}
</script>

<template>
  <Image
    v-if="img"
    :src="img"
    :alt="alt"
    class="bg-img"
    :fetch-priority="firstImage ? 'high' : undefined"
    :no-lazy="noLazy"
    :no-transition="noTransition"
    @load="onImageLoad"
  />
</template>

<style scoped lang="postcss">
.bg-img {
  @apply absolute bottom-0 left-0 right-0 top-0;
  z-index: -1;
}

.bg-img:deep() {
  .image-wrapper {
    @apply bg-gray-800;
  }

  img {
    @apply block h-full w-full object-cover object-center;
  }
}
</style>
